///////////////////////////////////////////////////

import { isDefined } from '@sgme/fp';
import { isSecondaryMarketQuotesRtFormPersistedTabContent } from 'apiConnector/tabs/secondaryMarket.tabs.model';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { filter, mergeMap, withLatestFrom } from 'rxjs/operators';
import type { Action } from 'state/actions';
import { secondaryMarketAstroClientRequested } from 'state/secondaryMarket/referential/astroClient/astroClient.actions';
import { secondaryMarketAstroProductFetchRequested } from 'state/secondaryMarket/referential/astroProduct/astroProduct.actions';
import { getKeyCode } from 'state/secondaryMarket/utils';
import type { EpicWithThunk } from 'state/state.common';
import { getProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.selector';
export function loadAfterRtQuoteTabContentFetchedEpic(): EpicWithThunk {
  return (actions$, state$) => {
    return actions$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCHED'),
      filter(({ workspace, tabType }) => workspace === 'secondaryMarketQuotes' && tabType === 'realtimeQuote'),
      withLatestFrom(state$),
      mergeMap(([{ tabContent, tabId }, state]) => {
        if (!isSecondaryMarketQuotesRtFormPersistedTabContent(tabContent)) {
          return EMPTY;
        }
        const productKey = getProductKey(state, tabId);
        const isin = getKeyCode(productKey)!;
        const actions: Action[] = [secondaryMarketAstroProductFetchRequested(isin, tabId)];
        if (isDefined(tabContent.client?.id)) {
          actions.push(secondaryMarketAstroClientRequested(tabId, tabContent.client.id));
        }
        return of(...actions);
      }),
    );
  };
}
